import { InjectionToken } from '@angular/core';

export const token = new InjectionToken<any>('settingFieldData');
